import { matchRoutes } from 'react-router-config';

import routes from '@src/routes';
import config from '@src/config';

const PROD_BASE_DOMAIN = 'app.videopeel.com';
const STAGING_BASE_DOMAIN = 'staging.videopeel.com';
const DEV_BASE_DOMAIN = 'http://localhost:3000';

const isPreviewablePage = () => {
  const matchedRoutes = matchRoutes(routes, window.location.pathname);
  const currentRoute = matchedRoutes[0].match;

  if (
    currentRoute.path === '/c/:link' ||
    currentRoute.path === '/:id' ||
    currentRoute.path === '/share/:pageType?/:mediaId/:fileName'
  ) {
    return true;
  }
  return false;
};

const isCustomDomain = () => {
  const currentDomain = window.location.host;
  return currentDomain !== config.baseAppDomain && currentDomain !== config.appAlternateDomain;
};

export const shouldPreventCustomDomainAccess = () => {
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
    return false;
  }

  if (isCustomDomain() && !isPreviewablePage()) {
    return true;
  }

  return false;
};

export const getBaseCampaignUrl = (customDomain) => {
  if (!config?.subdomainBaseUrl || !customDomain) {
    return window.location.host;
  }

  return `${customDomain}.${config.subdomainBaseUrl}`;
};

export const shouldPreventCustomDomainClpAccess = (campaignCustomDomain) => {
  const currentDomain = window.location.host;
  const isVideopeelSubdomain =
    !!config.subdomainBaseUrl && currentDomain.endsWith(`.${config.subdomainBaseUrl}`);

  if (config.baseAppDomain && isVideopeelSubdomain) {
    const isCustomDomain = currentDomain !== config.baseAppDomain;
    if (isCustomDomain) {
      if (campaignCustomDomain !== currentDomain.split('.')[0]) {
        window.location.href = `https://${config.baseAppDomain}${window.location.pathname}`;
        return true;
      }
    }
  }
  return false;
};

const redirectToAllowedSubdomain = () => {
  window.location.href = `https://${config.baseAppDomain}${window.location.pathname}`;
};

export const preventCustomDomainAccess = () => {
  if (shouldPreventCustomDomainAccess()) {
    redirectToAllowedSubdomain();
  }
};

export const preventCustomDomainClpAccess = (clpCustomDomain) => {
  if (shouldPreventCustomDomainClpAccess(clpCustomDomain)) {
    redirectToAllowedSubdomain();
  }
};

export const buildCustomVideoPeelUrl = (customDomain) => {
  // adding ugly fallback based on env because we want to be able to unit test
  // this easily while running locally
  const defaultUrl = process.env.NODE_ENV === 'test' ? PROD_BASE_DOMAIN : config.baseAppDomain;

  // Force return localhost if base app domain is empty based on config
  if (!defaultUrl) {
    return DEV_BASE_DOMAIN;
  }

  const splitUrl = defaultUrl.split('.');

  const customUrl =
    defaultUrl === STAGING_BASE_DOMAIN
      ? `https://${customDomain}.${splitUrl[0]}.${splitUrl[1]}.${splitUrl[2]}`
      : `https://${customDomain}.${splitUrl[1]}.${splitUrl[2]}`;

  return customUrl;
};



// WEBPACK FOOTER //
// ./src/helpers/customDomainsHelper.js